import NotBookedState from '@rio-cloud/rio-uikit/NotBookedState';
import IframeResizer from '@rio-cloud/iframe-resizer';
import { FormattedMessage } from 'react-intl';

import { getUserProfile } from '../../configuration/login/loginSlice';
import { useAppSelector } from '../../configuration/setup/hooks';

const BUY_BUTTON_LINK = 'https://buybutton.marketplace.rio.cloud/?productId=rio-sku00000047&level=15';
const UPSELLING_LINK = 'https://upselling.marketplace.rio.cloud/?productId=latam-sku00000006&level=15';
const LATAM_TENANT_PREFIX = 'rio-brazil';

export const NoProductBooking = () => {
    const userProfile = useAppSelector(getUserProfile);
    if (userProfile?.tenant?.startsWith(LATAM_TENANT_PREFIX)) {
        return <IframeResizer title='Geofencing product information' src={UPSELLING_LINK} />;
    }
    return (
        <NotBookedState
            headline={<FormattedMessage id={'intl-msg:MissingProduct.heading'} />}
            message={<FormattedMessage id={'intl-msg:MissingProduct.description'} />}
        >
            <iframe
                title={'buyButton'}
                className={'buyButton border-none width-100pct height-40'}
                src={BUY_BUTTON_LINK}
            />
        </NotBookedState>
    );
};
